export default "__VITE_ASSET__df889332__"